function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 14,
  r: 13.25,
  transform: "matrix(-1 0 0 1 38 10)",
  stroke: "#333",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.453 23.582l4.42-4.339a.854.854 0 011.195.003.826.826 0 01-.003 1.18L20.1 23.339h10.055a.84.84 0 01.846.834.84.84 0 01-.846.834H20.1l2.966 2.913a.827.827 0 01.003 1.18.854.854 0 01-1.196.003l-4.418-4.339a.828.828 0 010-1.182z",
  fill: "#333"
});

function SvgIconLeftArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTQiIGN5PSIxNCIgcj0iMTMuMjUiIHRyYW5zZm9ybT0ibWF0cml4KC0xIDAgMCAxIDM4IDEwKSIgc3Ryb2tlPSIjMzMzMzMzIiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8cGF0aCBkPSJNMTcuNDUzNCAyMy41ODIzTDIxLjg3MjUgMTkuMjQzQzIyLjIwMzUgMTguOTE3OSAyMi43Mzg5IDE4LjkxOTIgMjMuMDY4MyAxOS4yNDU4QzIzLjM5NzggMTkuNTcyNCAyMy4zOTY1IDIwLjEwMDYgMjMuMDY1NSAyMC40MjU3TDIwLjA5OSAyMy4zMzg1SDMwLjE1NDRDMzAuNjIxNCAyMy4zMzg1IDMxIDIzLjcxMjEgMzEgMjQuMTcyOUMzMSAyNC42MzM3IDMwLjYyMTQgMjUuMDA3MiAzMC4xNTQ0IDI1LjAwNzJIMjAuMDk5MUwyMy4wNjU1IDI3LjkyQzIzLjM5NjUgMjguMjQ1MSAyMy4zOTc3IDI4Ljc3MzMgMjMuMDY4MyAyOS4wOTk5QzIyLjczODggMjkuNDI2NiAyMi4yMDM0IDI5LjQyNzcgMjEuODcyNCAyOS4xMDI3TDE3LjQ1NDEgMjQuNzY0MkMxNy4xMjI5IDI0LjQzODEgMTcuMTIzMiAyMy45MDczIDE3LjQ1MzQgMjMuNTgyM1oiIGZpbGw9IiMzMzMzMzMiLz4KPC9zdmc+Cg==";
export { SvgIconLeftArrow as ReactComponent };